import { AgFilterComponent } from 'ag-grid-angular';
import { IFilterParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'app-trademark-filter',
  standalone: false,
  templateUrl: './trademark-filter.component.html',
  styleUrls: ['./trademark-filter.component.scss'],
})
export class TrademarkFilterComponent implements AgFilterComponent {
  params: IFilterParams | undefined;

  trademarkInputValue: string | undefined = '';
  filterConditions: string[] = ['AND', 'OR'];
  selectedCondition: 'OR' | 'AND' = 'AND';

  filterModel: {
    filter: string[];
    filterCondition: 'AND' | 'OR';
    filterType: string;
  } = {
    filter: [],
    filterCondition: this.selectedCondition,
    filterType: 'customText',
  };

  hidePopup: (() => void) | undefined = () => {};
  constructor() {}

  agInit(params: IFilterParams<any>): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return !!this.trademarkInputValue?.trim();
  }

  doesFilterPass(): boolean {
    return true;
  }
  getModel(): any {
    this.getFiltervalue();
    const hasFilter = this.filterModel.filter.length > 0;
    if (!hasFilter) {
      return undefined;
    }

    return {
      filter: this.filterModel.filter,
      filterType:
        hasFilter && this.filterModel.filter.length > 1
          ? 'condition'
          : 'customText',
      filterCondition: this.selectedCondition,
    };
  }

  setModel(model: any): void {
    if (!!model) {
      this.filterModel = model;
      this.trademarkInputValue = model.filter.join(', ');
      this.selectedCondition = model.filterCondition || 'AND';
    } else {
      this.clearFilter();
    }
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    this.hidePopup = params?.hidePopup;
  }

  clearFilter(): void {
    this.setdefaults();
  }

  private setdefaults(): void {
    this.trademarkInputValue = '';
    this.filterModel.filter = [];
    this.selectedCondition = 'AND';
    this.filterModel.filterCondition = this.selectedCondition;
  }

  applyFilter(): void {
    this.getFiltervalue();
    this.hidePopup!();
    this.params?.filterChangedCallback();
  }

  getFiltervalue(): void {
    if (!this.trademarkInputValue) {
      this.filterModel.filter = [];
      return;
    }

    this.filterModel.filter = this.trademarkInputValue
      .split(',')
      .filter((val) => val.trim() !== '');
  }
}
